import React from 'react';
import { withRouter } from '../../../services/withRoute';
import ProjectTable from '../../components/projectTable';
import ProjectsGraphQlController from '../../../controllers/projectsGraphQl';
import McListTableRow from '../../components/mcListTableRow';
import { ReactComponent as PendingIcon } from '../../../assets/svg/pending.svg';
import { ReactComponent as SearchIcon } from '../../../assets/svg/search.svg';
import { ReactComponent as DownIcon } from '../../../assets/svg/chevron-down.svg';
import _, { times } from 'lodash';
import LoadingBar from '../../components/global/loadingBar';
import Filter from '../../components/filter';
import { gql } from '@apollo/client';
import MemoryCardTable from './MemoryCardTable';
import DataTableCompact from '../../components/DataTableCompact';
// import { Data } from './data'
import PieChart from './PieChart';
import equipmentConstants from '../../../utils/equipmentConstants';

const getVendorMCList = gql`
	query MemoryCardList(
		$filters: VendorsMcListFiltersInput
		$branchIds: [String!]
		$memoryCardSummaryFilters2: McSummaryFilters
	) {
		memoryCardList(filters: $filters) {
			data {
				qrCode
				description
				status
				type
				size
				lastUsedBy {
					tenantId
					workspaceId
					projectId
					projectName
					projectSlNo
					eventId
					eventName
					eventSlNo
					userId
					userName
					usedAt
					__typename
				}
				id
				__typename
			}
			totalPages
			totalDocs
			limit
			currentPage
			hasNextPage
			hasPrevPage
			prevPage
			nextPage
			__typename
		}
		memoryCardSummary(branchIds: $branchIds, filters: $memoryCardSummaryFilters2) {
			total
			type
			size
			subStatusModel {
				subStatusCount
				subStatus
			}
		}
	}
`;

/*
		branchesList {
			branchId
		}
		vendorTenantUsersList(filters: $vendorTenantUsersListFilters2) {
			data {
				isEmailVerified
				lastName
				firstName
				id
				__typename
			}
			totalPages
			totalDocs
			limit
			currentPage
			hasNextPage
			nextPage
			__typename
		}
		vendorsProjects(filters: $vendorsProjectsFilters2) {
			data {
				id
				title
			}
			totalPages
			totalDocs
			limit
			currentPage
			hasNextPage
			hasPrevPage
			prevPage
			nextPage
		}

*/

const getBranchList = gql`
	query BranchesList {
		branchesList {
			branchId
		}
	}
`;

const getVendorUsers = gql`
	query VendorUsers {
		vendorUsers {
			id
			firstName
			lastName
			phoneNumber
			displayName
		}
	}
`;

const getProjects = gql`
	query VendorsProjects($filters: projectsListFiltersInput) {
		vendorsProjects(filters: $filters) {
			data {
				id
				title
			}
			totalPages
			totalDocs
			limit
			currentPage
			hasNextPage
			hasPrevPage
			prevPage
			nextPage
		}
	}
`;

const getVendorInfo = gql`
	query VendorInfo($vendorId: String!) {
		vendorInfo(vendorId: $vendorId) {
			id
			businessName
			vendorId
			isSuperHuemn
			associatedTenants {
				_id
				workspaceId
				workspaceKey
			}
		}
	}
`;
const getMemoryCardSummary = gql`
	query MemoryCardSummary($filters: McSummaryFilters, $branchIds: [String!]) {
		memoryCardSummary(filters: $filters, branchIds: $branchIds) {
			total
			type
			size
			subStatusModel {
				subStatusCount
				subStatus
			}
		}
	}
`;

class Shoots extends ProjectsGraphQlController {
	constructor() {
		super();
		this.state = {
			isLoading: true,
			limit: 30,
			page: 1,
			searchQuery: '',
			sortBy: '',
			sortType: 0,
			currentViewPage: 1,
			isPageLoading: false,
			memoryCardSummaryList: [],
			totalPages: 1,
			mcList: [],
			chartdata: [],

			ownerIdActiveFilter: 'createdAt',
			tenantUsersList: {},
			assignedToFilters: {},
			columns: [
				{ title: 'QR Code' },
				{ title: 'Type/Size' },
				{ title: 'Status' },
				// { title: 'Workspace' },
				{ title: 'Event' },
				{ title: 'Assigned To' },
			],
			projectsFilters: [],
			statusFilters: equipmentConstants.memoryCard.statusFilters,
			typeFilters: equipmentConstants.memoryCard.typeFilters,
			sizeFilters: equipmentConstants.memoryCard.sizeFilters,
			subStatusFilters: equipmentConstants.memoryCard.subStatusFilters,
			workspacesFilters: [],
			typeActiveFilter: [],
			sizeActiveFilter: '',
			statusActiveFilter: '',
			projectActiveFilter: [],
			workspaceActiveFilter: '',
			assignedToActiveFilter: [],
			subStatusActiveFilter: [],
			qrCodeActiveFilter: '',
			projectSlNoActiveFilter: '',
			eventSlNoActiveFilter: '',
			userPageLimit: 10000,
			userPage: 1,
			userHasNextPage: true,
			projectFilters: [],
			showSearchDropDown: false,
			searchType: 'qrCode',
			branchIdsActiveFilter: [],
			totMemoryCards: 0,
			tempdata: [],
			memoryCardsNumbers: [],
			isBranchIdsFiltersLoading: true,
			isProjectsLoading: true,
			isVendorUsersLoading: true,
		};

		this.searchDropDownRef = React.createRef();
		this.wrapper = React.createRef();
	}

	componentDidMount = async () => {
		let searchURL = new URLSearchParams(window.location.search);

		let res1 = false;
		res1 = await this.getVendorsWorkspaces(getVendorInfo, {
			vendorId: this.props.params.vendorID,
		});

		//await this.getMemoryCardSummaryList(getMemoryCardSummary, summaryJson);

		if (res1 !== false) {
			let json = {};
			let urlSearch =
				_.size(window.location.search.split('?')) > 1
					? window.location.search.split('?')[1].split('&')
					: [];
			if (_.size(urlSearch) > 0) {
				let count = 0;
				let tempCount = 0;
				let searchType = null;
				let tempUrlSearch = _.cloneDeep(urlSearch);
				while (tempCount < _.size(tempUrlSearch)) {
					let subString = tempUrlSearch[tempCount].split('=');

					if (subString[0] && subString[0] === 'searchType') {
						searchType = subString[1];
					}
					tempCount++;
				}
				while (count < _.size(urlSearch)) {
					let subString = urlSearch[count].split('=');

					if (subString[0] && subString[0] !== 'searchType')
						json = {
							filters: {
								...json.filters,
								[`${subString[0] === 'search' ? searchType : subString[0]}`]:
									subString[0] === 'page' || subString[0] === 'limit'
										? parseInt(subString[1])
										: subString[0] === 'search'
										? searchType === 'qrCode'
											? subString[1].trim()
											: subString[1].slice(0, 3).toLowerCase() === 'st-' ||
											  subString[1].slice(0, 3).toLowerCase() === 'pj-'
											? isNaN(subString[1].slice(3))
												? subString[1].slice(3)
												: parseInt(subString[1].slice(3))
											: subString[1]
										: subString[0] === 'status' || subString[0] === 'size'
										? subString[1]
										: subString[0] === 'wsTenantIds'
										? [subString[1]]
										: subString[1].split(','),
							},
						};
					if (subString[0] === 'search') {
						this.setState({
							searchType,
						});
					}
					this.setState({
						[`${
							subString[0] === 'wsTenantIds'
								? 'workspace'
								: subString[0] === 'projectIds'
								? 'project'
								: subString[0] === 'search'
								? searchType
								: subString[0]
						}ActiveFilter`]:
							subString[0] === 'search' ||
							subString[0] === 'status' ||
							subString[0] === 'size' ||
							subString[0] === 'wsTenantIds'
								? subString[1]
								: subString[1].split(','),
					});

					count++;
				}
			} else {
				json = {
					filters: {
						limit: this.state.limit,
						page: this.state.currentViewPage,
					},
				};
			}

			if (searchURL.has('branchIds')) {
				json.branchIds = searchURL.get('branchIds').split(',');
			}

			if (searchURL.has('wsTenantIds')) {
				let workspaceId = null;
				workspaceId = _.find(res1, { key: searchURL.get('wsTenantIds') });
				if (workspaceId && _.has(workspaceId, 'name')) {
					json.memoryCardSummaryFilters2 = {
						workspaceId: workspaceId.name,
					};
				}
			}

			this.getVendorMCList(getVendorMCList, json);
		}

		this.getBranchList2(getBranchList, 'branchIdsFilters');

		let projectFilters = [];
		let res2 = false;

		let projectsJson = {
			filters: { limit: 10000, page: 1 },
		};

		res2 = await this.getProjects(getProjects, projectsJson);

		if (res2 !== false) {
			projectFilters = res2;
			this.setState({
				projectFilters,
				isProjectsLoading: false,
			});
		}

		this.getTenantUsers(getVendorUsers);

		document.addEventListener('mousedown', this.handleClickOutside);
	};

	componentWillUnmount() {
		document.removeEventListener('mousedown', this.handleClickOutside);
	}

	handleClickOutside = (event) => {
		if (
			this.searchDropDownRef.current &&
			!this.searchDropDownRef.current.contains(event.target) &&
			this.wrapper.current &&
			!this.wrapper.current.contains(event.target)
		) {
			this.setState({
				showSearchDropDown: false,
			});
		}
	};

	toggleSearchDropDown = () => {
		this.setState({
			showSearchDropDown: !this.state.showSearchDropDown,
		});
	};

	toggleSearchType = (e, type) => {
		let tempActiveFilter = this.state[`${this.state.searchType}ActiveFilter`];
		this.setState(
			{
				[`${this.state.searchType}ActiveFilter`]: '',
				[`${type}ActiveFilter`]: tempActiveFilter,
				searchType: type,
				showSearchDropDown: false,
				isPageLoading: _.size(tempActiveFilter.trim()) > 0,
				currentViewPage: 1,
			},
			() => {
				if (_.size(this.state[`${this.state.searchType}ActiveFilter`].trim()) > 0) {
					this.fetchMoreShoots();
				}
			},
		);
	};

	onClickNextPage = async () => {
		if (this.state.currentViewPage < this.state.totalPages) {
			this.setState(
				{
					currentViewPage: this.state.currentViewPage + 1,
					isPageLoading: true,
				},
				async () => {
					await this.fetchMoreShoots();
				},
			);
		}
	};
	handleGoToPage = async (e) => {
		this.setState(
			{
				currentViewPage: e,
				isPageLoading: true,
			},
			async () => {
				await this.fetchMoreShoots();
			},
		);
	};
	onClickPreviousPage = async () => {
		if (this.state.currentViewPage > 1) {
			this.setState(
				{
					currentViewPage: this.state.currentViewPage - 1,
					isPageLoading: true,
				},
				async () => {
					await this.fetchMoreShoots();
				},
			);
		}
	};

	fetchMoreShoots = async () => {
		let queryString = `?page=${this.state.currentViewPage}&limit=${this.state.limit}`;

		//Condition for MC Type
		if (_.size(this.state.typeActiveFilter) > 0)
			queryString = `${queryString}&type=${this.state.typeActiveFilter.toString()}`;

		//Condition for MC Size
		if (_.size(this.state.sizeActiveFilter) > 0)
			queryString = `${queryString}&size=${this.state.sizeActiveFilter.toString()}`;

		//Condition for MC Size
		if (_.size(this.state.workspaceActiveFilter) > 0)
			queryString = `${queryString}&wsTenantIds=${this.state.workspaceActiveFilter.toString()}`;

		//Condition for MC Status
		if (_.size(this.state.statusActiveFilter) > 0)
			queryString = `${queryString}&status=${this.state.statusActiveFilter}`;

		//Condition for MC Sub Status
		if (_.size(this.state.subStatusActiveFilter) > 0)
			queryString = `${queryString}&subStatus=${this.state.subStatusActiveFilter}`;

		//Condition for Assigned To
		if (_.size(this.state.assignedToActiveFilter) > 0)
			queryString = `${queryString}&assignedTo=${this.state.assignedToActiveFilter.toString()}`;

		if (_.size(this.state.branchIdsActiveFilter) > 0)
			queryString = `${queryString}&branchIds=${this.state.branchIdsActiveFilter.toString()}`;
		//Condition for Search String
		if (_.size(this.state[`${this.state.searchType}ActiveFilter`].trim()) > 0)
			queryString = `${queryString}&search=${this.state[
				`${this.state.searchType}ActiveFilter`
			].trim()}&searchType=${this.state.searchType}`;

		//Condition for projects
		if (_.size(this.state.projectActiveFilter) > 0)
			queryString = `${queryString}&projectIds=${this.state.projectActiveFilter.toString()}`;

		//Condition for Search String
		if (_.size(this.state[`${this.state.searchType}ActiveFilter`].trim()) > 0)
			queryString = `${queryString}&search=${this.state[
				`${this.state.searchType}ActiveFilter`
			].trim()}&searchType=${this.state.searchType}`;

		this.props.navigate(`/${this.props.params.vendorID}/memory-cards${queryString}`);

		let json = {
			filters: {
				page: this.state.currentViewPage,
				limit: this.state.limit,
			},
		};

		//Condition for Status
		if (_.size(this.state.statusActiveFilter) > 0)
			json = {
				filters: {
					...json.filters,
					status: this.state.statusActiveFilter,
				},
			};
		//Condition for Assigned To
		if (_.size(this.state.assignedToActiveFilter) > 0)
			json = {
				filters: {
					...json.filters,
					assignedTo: this.state.assignedToActiveFilter,
				},
			};

		//Condition for Project
		if (_.size(this.state.projectActiveFilter) > 0)
			json = {
				filters: {
					...json.filters,
					projectIds: this.state.projectActiveFilter,
				},
			};

		//Condition for Type
		if (_.size(this.state.typeActiveFilter) > 0)
			json = {
				filters: {
					...json.filters,
					type: this.state.typeActiveFilter,
				},
			};
		//Condition for Size
		if (_.size(this.state.sizeActiveFilter) > 0)
			json = {
				filters: {
					...json.filters,
					size: this.state.sizeActiveFilter,
				},
			};

		//Condition for Sub Status
		if (_.size(this.state.subStatusActiveFilter) > 0)
			json = {
				filters: {
					...json.filters,
					subStatus: this.state.subStatusActiveFilter,
				},
			};

		//Condition for Workspace
		if (_.size(this.state.workspaceActiveFilter) > 0) {
			json = {
				filters: {
					...json.filters,
					wsTenantIds: this.state.workspaceActiveFilter,
				},
				memoryCardSummaryFilters2: {
					workspaceId: _.find(this.state.workspacesFilters, {
						key: this.state.workspaceActiveFilter,
					})?.name,
				},
			};
		}

		if (_.size(this.state.branchIdsActiveFilter) > 0) {
			json = {
				...json,
				filters: {
					...json.filters,
					branchIds: this.state.branchIdsActiveFilter,
				},
				branchIds: this.state.branchIdsActiveFilter,
			};
		}

		//condition for search
		if (_.size(this.state[`${this.state.searchType}ActiveFilter`].trim()) > 0) {
			json.filters[this.state.searchType] =
				this.state.searchType === 'qrCode'
					? this.state[`${this.state.searchType}ActiveFilter`].trim()
					: this.state[`${this.state.searchType}ActiveFilter`]
							.slice(0, 3)
							.toLowerCase() === 'st-' ||
					  this.state[`${this.state.searchType}ActiveFilter`]
							.slice(0, 3)
							.toLowerCase() === 'pj-'
					? isNaN(this.state[`${this.state.searchType}ActiveFilter`].slice(3))
						? this.state[`${this.state.searchType}ActiveFilter`].slice(3)
						: parseInt(this.state[`${this.state.searchType}ActiveFilter`].slice(3))
					: this.state[`${this.state.searchType}ActiveFilter`];
		}

		this.getVendorMCList(getVendorMCList, json);
	};

	handleActiveFilter = (e, type, key) => {
		let array;

		if (type === 'status' || type === 'size') {
			array = key === this.state[`${type}ActiveFilter`] ? '' : key;
		} else {
			array = [...this.state[`${type}ActiveFilter`]];

			if (array.includes(key) == false) {
				array.push(key);
			} else {
				const index = array.indexOf(key);
				if (index > -1) {
					array.splice(index, 1); // 2nd parameter means remove one item only
				}
			}
		}

		this.setState(
			{
				[`${type}ActiveFilter`]: array,
				currentViewPage: 1,
				isPageLoading: true,
			},
			() => this.fetchMoreShoots(),
		);
	};
	applyFilter = (filter, type) => {
		this.setState(
			{
				[`${type}ActiveFilter`]: filter,
				currentViewPage: 1,
				mcList: [],
				isPageLoading: true,
			},
			() => {
				this.fetchMoreShoots();
			},
		);
	};
	handleclearSelection = (e, type) => {
		this.setState(
			{
				[`${type}ActiveFilter`]:
					type === 'status' || type === 'size' || type === 'workspace' ? '' : [],
				currentViewPage: 1,
				isPageLoading: true,
			},
			() => this.fetchMoreShoots(),
		);
	};

	searchString = (e) => {
		this.setState({
			[`${this.state.searchType}ActiveFilter`]: e.target.value,
			isPageLoading: true,
			currentViewPage: 1,
		});

		if (this.timeout) clearTimeout(this.timeout);
		this.timeout = setTimeout(async () => {
			this.fetchMoreShoots();
		}, 1000);
	};

	handleSummaryClick = (type, size, status, subStatus) => {
		this.setState(
			{
				isPageLoading: true,
				currentViewPage: 1,
				typeActiveFilter: [type],
				sizeActiveFilter: size,
				statusActiveFilter: status === null ? '' : status,
				subStatusActiveFilter: subStatus === null ? [] : [subStatus],
			},
			() => {
				this.fetchMoreShoots();
			},
		);
	};

	render() {
		return (
			<div className="layout-wrapper">
				{this.state.isLoading ? (
					<div className="container">
						<LoadingBar />
					</div>
				) : (
					<div className="container">
						<div className="searchContainer">
							<a className="title">Memory Card</a>
							<div className="searchWrapper">
								<div className="search-inner-left">
									<span className="search-icon">
										<SearchIcon />
									</span>
									<input
										placeholder="Search"
										id="search"
										name={this.state.searchType}
										value={this.state[`${this.state.searchType}ActiveFilter`]}
										onChange={(e) => this.searchString(e)}
									/>
								</div>
								<div className="search-inner-right">
									<span className="in-text">in</span>
									<span
										className="search-dropdown-btn"
										style={{ position: 'relative' }}
									>
										<a
											className="search-type"
											onClick={(e) => this.toggleSearchDropDown(e)}
											ref={this.wrapper}
										>
											{this.state.searchType === 'qrCode'
												? 'QR Code'
												: this.state.searchType === 'projectSlNo'
												? 'Project ID'
												: this.state.searchType === 'eventSlNo'
												? 'Shoot ID'
												: ''}
											<b
												className={
													this.state.showSearchDropDown ? 'invert' : ''
												}
											>
												<DownIcon />
											</b>
										</a>
										{this.state.showSearchDropDown ? (
											<div
												className="search-dropdown right-zero search-type"
												ref={this.searchDropDownRef}
											>
												<a
													className={`item ${
														this.state.searchType === 'qrCode'
															? 'active'
															: ''
													}`}
													onClick={(e) =>
														this.toggleSearchType(e, 'qrCode')
													}
												>
													QR Code
												</a>
												<a
													className={`item ${
														this.state.searchType === 'projectSlNo'
															? 'active'
															: ''
													}`}
													onClick={(e) =>
														this.toggleSearchType(e, 'projectSlNo')
													}
												>
													Project ID
												</a>
												<a
													className={`item ${
														this.state.searchType === 'eventSlNo'
															? 'active'
															: ''
													}`}
													onClick={(e) =>
														this.toggleSearchType(e, 'eventSlNo')
													}
												>
													Shoot ID
												</a>
											</div>
										) : (
											''
										)}
									</span>
								</div>
							</div>
						</div>

						<div className="filters">
							<Filter
								type={'type'}
								label={'Category'}
								version="v2"
								applyFilter={this.applyFilter}
								filters={this.state.typeFilters}
								activeFilter={this.state.typeActiveFilter}
								handleActiveFilter={(e, type, key) =>
									this.handleActiveFilter(e, 'type', key)
								}
								clearSelection={(e) => this.handleclearSelection(e, 'type')}
								isMultipleSelectable={true}
							/>
							<Filter
								type={'size'}
								label={'Size'}
								version="v2"
								applyFilter={this.applyFilter}
								filters={this.state.sizeFilters}
								activeFilter={this.state.sizeActiveFilter}
								handleActiveFilter={(e, type, key) =>
									this.handleActiveFilter(e, 'size', key)
								}
								clearSelection={(e) => this.handleclearSelection(e, 'size')}
								isMultipleSelectable={false}
							/>

							<Filter
								type={'workspace'}
								label={'Workspaces'}
								version="v2"
								applyFilter={this.applyFilter}
								filters={this.state.workspacesFilters}
								activeFilter={this.state.workspaceActiveFilter}
								handleActiveFilter={(e, status, key) =>
									this.handleActiveFilter(e, 'workspace', key)
								}
								clearSelection={(e) => this.handleclearSelection(e, 'workspace')}
								isMultipleSelectable={false}
							/>
							<Filter
								type={'status'}
								label={'Status'}
								version="v2"
								applyFilter={this.applyFilter}
								filters={this.state.statusFilters}
								activeFilter={this.state.statusActiveFilter}
								handleActiveFilter={(e, status, key) =>
									this.handleActiveFilter(e, 'status', key)
								}
								clearSelection={(e) => this.handleclearSelection(e, 'status')}
								isMultipleSelectable={false}
							/>
							<Filter
								type={'subStatus'}
								label={'Sub Status'}
								version="v2"
								applyFilter={this.applyFilter}
								filters={this.state.subStatusFilters}
								activeFilter={this.state.subStatusActiveFilter}
								handleActiveFilter={(e, status, key) =>
									this.handleActiveFilter(e, 'subStatus', key)
								}
								clearSelection={(e) => this.handleclearSelection(e, 'subStatus')}
								isMultipleSelectable={true}
							/>

							{this.state.isVendorUsersLoading === true ? null : (
								<Filter
									type={'assignedTo'}
									label={'AssignedTo'}
									version="v2"
									applyFilter={this.applyFilter}
									filters={this.state.assignedToFilters}
									activeFilter={this.state.assignedToActiveFilter}
									handleActiveFilter={(e, type, key) =>
										this.handleActiveFilter(e, 'assignedTo', key)
									}
									clearSelection={(e) =>
										this.handleclearSelection(e, 'assignedTo')
									}
									isMultipleSelectable={true}
								/>
							)}
							{this.state.isProjectsLoading === true ? null : (
								<Filter
									type={'project'}
									label={'Project'}
									version="v2"
									applyFilter={this.applyFilter}
									filters={this.state.projectFilters}
									activeFilter={this.state.projectActiveFilter}
									handleActiveFilter={(e, status, key) =>
										this.handleActiveFilter(e, 'project', key)
									}
									clearSelection={(e) => this.handleclearSelection(e, 'project')}
									isMultipleSelectable={true}
								/>
							)}
							{this.state.isBranchIdsFiltersLoading === true ? null : (
								<Filter
									type={'branchIds'}
									label={'Branch Id'}
									version="v2"
									applyFilter={this.applyFilter}
									filters={this.state.branchIdsFilters}
									activeFilter={this.state.branchIdsActiveFilter}
									handleActiveFilter={(e, type, key) =>
										this.handleActiveFilter(e, 'branchIds', key)
									}
									clearSelection={(e) =>
										this.handleclearSelection(e, 'branchIds')
									}
									isMultipleSelectable={true}
								/>
							)}
						</div>
						<div className={'table'}>
							<div
								className="mc-flexbod"
								style={{
									display: 'flex',
									gap: '20px',
								}}
							>
								<div className="mc-flexbod-2">
									<PieChart data={this.state.memoryCardSummaryList} />
									<MemoryCardTable
										data={this.state.memoryCardSummaryList}
										handleSummaryClick={this.handleSummaryClick}
									/>
								</div>
								<DataTableCompact
									tableHeaderLeftPad={35}
									isLoading={this.state.isLoading}
									tableHeader={`SHOOTS`}
									columns={this.state.columns}
									activeSortType={this.state.sortType}
									activeSortBy={this.state.sortBy}
									//handleSort={this.handleProjectSort}
									isPageLoading={this.state.isPageLoading}
									limit={this.state.limit}
									totalPages={this.state.totalPages}
									currentViewPage={this.state.currentViewPage}
									lengthOfList={this.state.lengthOfList}
									onClickNextPage={this.onClickNextPage}
									onClickPreviousPage={this.onClickPreviousPage}
									dataList={this.state.mcList}
									goToPage={(e) => this.handleGoToPage(e)}
									module={'project'}
									searchQuery={''}
									mainFilter={''}
								>
									{_.map(this.state.mcList, (shoot, index) => {
										// let workspaceDetails = _.find(
										// 	this.state.workspaceList,
										// 	{
										// 		_id: equipment.tenantId,
										// 	}
										// );
										return (
											<McListTableRow
												key={shoot.id}
												data={{
													...shoot,
													//workspaceDetails,
												}}
												workSpaceFilters={this.state.workspacesFilters}
											/>
										);
									})}
								</DataTableCompact>
							</div>
						</div>
					</div>
				)}
			</div>
		);
	}
}

export default withRouter(Shoots);
